module.exports = __webpack_public_path__ + "img/132w.df08108.jpg";